import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import {
  getBookingsMatrix,
  getBookingsReport,
  getCustomerMatrix,
  getCustomerReport,
} from 'redux/actions/ReportsAction';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import CommonButton from 'components/commonButton/CommonButton';
import CommonTable from 'components/commonTable/CommonTable';
import Loader from 'components/loader/Loader';
import { getDateFormat } from 'utils/utils';
import CommonReportCard from 'pages/reports/CommonReportCard';
import ReportsHeader from 'pages/reports/ReportsHeader/ReportsHeader';
import {
  customerFilterData,
  customerBreadcrumbPaths,
} from 'pages/reports/revenue/DummyDataReport';
import customerImg from 'assets/images/corporateCustomer.svg';

function CorporateCustomer() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [status, setStatus] = useState([]);
  const [location, setLocation] = useState([]);
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedParentCompany, setSelectedParentCompany] = useState('');
  const [selectedAllCompany, setSelectedAllCompany] = useState('');

  const barChartData =
    useSelector((state) => state?.getBookingMatrix?.bookingMatrix?.data) || {};
  const barChartLoader = useSelector(
    (state) => state?.getBookingMatrix?.loading
  );

  const customerData = useSelector(
    (state) => state?.getCustomerList?.customerList?.data
  );
  const customerMatrix =
    useSelector((state) => state?.getCustomerMatrix?.customerMatrix?.data) ||
    {};

  let customerReportPayload = {
    page: page,
    pageSize: rowsPerPage,
    status: status,
    location: location,
    dateTo: dateTo,
    dateFrom: dateFrom,
  };

  useEffect(() => {
    dispatch(getBookingsMatrix());
    dispatch(getBookingsReport());
    dispatch(getCustomerMatrix());
    dispatch(getCustomerReport(customerReportPayload));
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getCustomerReport({ ...customerReportPayload, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getCustomerReport({
        ...customerReportPayload,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  const onSelectDateRange = (newValue) => {
    if (newValue === null || newValue === 0) {
      setDateFrom('');
      setDateTo('');
      customerReportPayload = {
        ...customerReportPayload,
        dateFrom: '',
        dateTo: '',
      };
    } else {
      setDateFrom(getDateFormat(newValue[0], 'reservationDateFormat'));
      setDateTo(getDateFormat(newValue[1], 'reservationDateFormat'));
      customerReportPayload = {
        ...customerReportPayload,
        dateFrom: getDateFormat(newValue[0], 'reservationDateFormat'),
        dateTo: getDateFormat(newValue[1], 'reservationDateFormat'),
      };
    }
    dispatch(getCustomerReport(customerReportPayload));
  };

  //Filter Reset
  const onFilterChange = (val) => {
    const defaultLocation = ['rental', 'airport', 'outStation'];

    const filterLocations = val.filter((DutyType) => {
      return defaultLocation.includes(DutyType);
    });

    setLocation(filterLocations);

    const customerFilter = {
      ...customerReportPayload,
      location: filterLocations?.toString(),
      page: 0,
    };
    dispatch(getCustomerReport(customerFilter));
  };

  // ---Reset Filter---
  const onRestFilter = () => {
    dispatch(
      getCustomerReport({ ...customerReportPayload, status: '', location: '' })
    );
    setStatus([]);
    setLocation([]);
  };

  //---Company select and Parent Company

  const handleCityChange = (e) => {
    setSelectedCity(e.target.value);
  };

  const handleParentCompanyChange = (e) => {
    setSelectedParentCompany(e.target.value);
  };

  const handleAllCompanyChange = (e) => {
    setSelectedAllCompany(e.target.value);
  };

  return (
    <Box>
      <Box className="mtb30">
        <CommonBreadCrumb paths={customerBreadcrumbPaths} />
      </Box>
      <ReportsHeader
        filterData={customerFilterData}
        onFilterChange={onFilterChange}
        onRestFilter={onRestFilter}
        onSelectDateRange={onSelectDateRange}
        defaultStatus={status}
        defaultLocation={location}
        dateFrom={dateFrom}
        dateTo={dateTo}
        handleCityChange={handleCityChange}
        handleParentCompanyChange={handleParentCompanyChange}
        handleAllCompanyChange={handleAllCompanyChange}
      />
      {barChartLoader ? (
        <Loader />
      ) : (
        <CommonReportCard
          barChartData={barChartData}
          loader={barChartLoader}
          reveneChartData={customerMatrix}
          title={'Total No. of Corporate Customer'}
          image={customerImg}
        />
      )}
      <Box className="justifyBetween pb10">
        <Typography variant="body1" className="colorBlack">
          Corporate Customer Reports
        </Typography>
        <CommonButton name="Send Report to mail" btnClass="btnSm btnYellow" />
      </Box>
      <CommonTable
        data={customerData}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Box>
  );
}

export default CorporateCustomer;
